export default {
      id: "hat-usage",
      viewBox: "0 0 22 20",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#hat",
      toString: function () {
        return this.url;
      }
    }